import React from "react";
import styles from "./styles/result-modal.module.scss";
import CoverTab from "@/components/modal/result-modal/components/cover-tab";
import DownloadButton from "@/components/modal/result-modal/components/download-button";
import {
  getDownloadFileTitle,
  getNormalizedTitle,
} from "@/utils/history-helper";
import MusicPlayer from "@/components/pages/convert/components/music-player";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ShareCoverButton from "@/components/common/share-cover-button";
import { useConvertResult } from "@/components/pages/convert/hooks/use-convert-result";
import Image from "next/image";
import shareIcon from "@/assets/icons/share-icon-secondary.svg";

type ResultModalProps = {
  combinedFileName: string;
  instrumentalFileName: string;
  vocalFileName: string;
  icon?: string;
  format?: string;
  onSongsDownloaded: () => void;
  isOpen: boolean;
  convertId: string;
};

const ResultModal = ({
  combinedFileName,
  instrumentalFileName,
  vocalFileName,
  icon,
  format,
  onSongsDownloaded,
  convertId,
}: ResultModalProps) => {
  const {
    selectedFileUrl,
    selectedFileName,
    combinedFileUrl,
    instrumentalFileUrl,
    vocalFileUrl,
    activeTab,
    onTabClick,
    download,
  } = useConvertResult(
    combinedFileName,
    instrumentalFileName,
    vocalFileName,
    onSongsDownloaded,
  );

  return (
    <div className={styles.modal}>
      <div className={styles.header}>
        <div className={styles.header_text}>Generated cover</div>
      </div>
      <ToastContainer position="top-right" />
      <div className={styles.tabs_container}>
        {combinedFileName && (
          <CoverTab
            title="Combined"
            fileName={combinedFileName}
            fileUrl={combinedFileUrl}
            activeTab={activeTab}
            onClick={onTabClick}
          />
        )}
        {instrumentalFileName && (
          <CoverTab
            title="Instrumental"
            fileName={instrumentalFileName}
            fileUrl={instrumentalFileUrl}
            activeTab={activeTab}
            onClick={onTabClick}
          />
        )}
        {vocalFileName && (
          <CoverTab
            title="Vocal"
            fileName={vocalFileName}
            fileUrl={vocalFileUrl}
            activeTab={activeTab}
            onClick={onTabClick}
          />
        )}
      </div>
      <MusicPlayer
        title={getNormalizedTitle(selectedFileName)}
        url={selectedFileUrl}
        format={format}
        icon={icon}
        stickyProgress={true}
        underImageNode={
          <ShareCoverButton
            url={selectedFileUrl}
            contentId={convertId}
            featureType={"convert"}
          >
            <>
              Share
              <Image src={shareIcon} alt={""} />
            </>
          </ShareCoverButton>
        }
      />
      <div className={styles.footer}>
        <DownloadButton
          onClick={() =>
            download(selectedFileUrl, getDownloadFileTitle(selectedFileName))
          }
        />
      </div>
    </div>
  );
};

export default ResultModal;
